/* BYON R1 · Ficha: despacho según comuna (lo carga sections/byon-pdp-assets.liquid, defer).
   Textos canónicos del consolidado R1 §2.1 (C1-FIC-03). Hora de America/Santiago, días hábiles y feriados.
   Hora de corte: data-corte del bloque (settings.llega_max) o window.byonSettings.llega_max (contrato K6).
   Express = la comuna guardada está en la lista de sections/despacho-express.liquid (comunascon).
   Prueba de horarios: ?byon_now=AAAA-MM-DDTHH:MM (solo lo lee este archivo; hora de Santiago).
   R2-UX-07 (D-07, 26-sep): nota del Cyber si hoy o el día de salida caen en data-cyber="AAAA-MM-DD|AAAA-MM-DD"
   (snippets/byon-pdp-delivery.liquid; sin el atributo no hay nota). Va en la línea y en "Despacho y cambios".
   Guardar una comuna emite delivery_comuna_set (K1). API: window.byonPdpDelivery.render(). */
(function () {
  'use strict';
  if (window.byonPdpDelivery) return;
  var d = document;
  function qs(s, r) { return (r || d).querySelector(s); }
  function closest(el, s) { return el && el.closest ? el.closest(s) : null; }
  function track(ev, p) { (window.byonTrack || function () {})(ev, p); }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function box() {
    var b = d.querySelectorAll('[data-byon-delivery]');
    for (var i = 0; i < b.length; i++) { if (!closest(b[i], 'quick-add-modal')) return b[i]; }
    return null;
  }

  var DOW = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
  var MON = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function testNow() {
    var v = '';
    try { v = new URLSearchParams(window.location.search).get('byon_now') || ''; } catch (e) { v = ''; }
    var m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(v);
    if (!m) return null;
    var o = { y: +m[1], m: +m[2], d: +m[3], h: +m[4], mi: +m[5] };
    return o.m >= 1 && o.m <= 12 && o.d >= 1 && o.d <= 31 && o.h <= 23 && o.mi <= 59 ? o : null;
  }
  function santiagoNow() {
    var t = testNow();
    if (t) return t;
    try {
      var o = {};
      new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Santiago', year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', hourCycle: 'h23'
      }).formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
      return { y: +o.year, m: +o.month, d: +o.day, h: (+o.hour) % 24, mi: +o.minute };
    } catch (e) {
      var x = new Date();
      return { y: x.getFullYear(), m: x.getMonth() + 1, d: x.getDate(), h: x.getHours(), mi: x.getMinutes() };
    }
  }
  function mk(y, m, dd) { return new Date(Date.UTC(y, m - 1, dd, 12)); }
  function iso(dt) { return dt.getUTCFullYear() + '-' + pad(dt.getUTCMonth() + 1) + '-' + pad(dt.getUTCDate()); }
  function addDays(dt, n) { return new Date(dt.getTime() + n * 86400000); }
  function isBiz(dt, hol) { var w = dt.getUTCDay(); return w !== 0 && w !== 6 && hol.indexOf(iso(dt)) === -1; }
  function nextBiz(dt, hol) { var x = addDays(dt, 1); for (var i = 0; i < 20 && !isBiz(x, hol); i++) x = addDays(x, 1); return x; }
  function longDay(dt) { return DOW[dt.getUTCDay()] + ' ' + dt.getUTCDate() + '-' + MON[dt.getUTCMonth()]; }
  function shortDay(dt) { return DOW[dt.getUTCDay()] + ' ' + dt.getUTCDate(); }
  function dur(min) {
    var h = Math.floor(min / 60), m = min % 60;
    if (h > 0) return h + ' h' + (m ? ' ' + m + ' min' : '');
    return (m || 1) + ' min';
  }
  function clean(v) { return v && v !== 'null' && v !== 'undefined' ? v : ''; }
  function savedComuna() {
    var v = '';
    try { v = window.localStorage.getItem('comuna') || ''; } catch (e) { v = ''; }
    if (!clean(v)) { var t = d.getElementById('header-select-town'); if (t && t.value) v = t.value; }
    return clean(v);
  }
  function savedRegion() {
    try { return clean(window.localStorage.getItem('region') || ''); } catch (e) { return ''; }
  }
  function expressList() {
    try { if (Array.isArray(comunascon)) return comunascon; } catch (e) { /* no declarada */ }
    return Array.isArray(window.byonComunasExpress) ? window.byonComunasExpress : [];
  }
  function comunaData() {
    try {
      if (header_cities && typeof header_cities === 'object' && header_towns && typeof header_towns === 'object') {
        return { cities: header_cities, towns: header_towns };
      }
    } catch (e) { /* desplegable-comunas no está en la página */ }
    return null;
  }
  function corteHour(b) {
    var c = parseInt(b.getAttribute('data-corte'), 10);
    if (!(c >= 0 && c <= 23)) c = Number(window.byonSettings && window.byonSettings.llega_max);
    return c >= 0 && c <= 23 ? Math.floor(c) : 12;
  }
  function cyber(b, today, ship) {
    var w = (b.getAttribute('data-cyber') || '').split('|');
    var re = /^\d{4}-\d{2}-\d{2}$/;
    if (w.length !== 2 || !re.test(w[0]) || !re.test(w[1])) return false;
    var t = iso(today), s = iso(ship);
    return (t >= w[0] && t <= w[1]) || (s >= w[0] && s <= w[1]);
  }
  /* Misma nota en el 1.er párrafo de "Despacho y cambios" (snippets/byon-pdp-accordions.liquid, #byon-acc-despacho) */
  function accNote(on) {
    var ps = d.querySelectorAll('#byon-acc-despacho .byon-acc__body > p');
    for (var i = 0; i < ps.length; i++) {
      var s = qs('.byon-cyber-note', ps[i]);
      if (on && !s) {
        s = d.createElement('span');
        s.className = 'byon-cyber-note';
        s.textContent = ' En días de evento Cyber, el despacho puede tomar 1 día hábil más.';
        ps[i].appendChild(s);
      } else if (!on && s) {
        ps[i].removeChild(s);
      }
    }
  }

  function render() {
    var b = box();
    if (!b) return;
    var out = qs('[data-byon-delivery-text]', b);
    var act = qs('[data-byon-delivery-action]', b);
    if (!out) return;
    var corte = corteHour(b);
    var hora = corte + ':00';
    var hol = (b.getAttribute('data-feriados') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var comuna = savedComuna();
    var n = santiagoNow();
    var today = mk(n.y, n.m, n.d);
    var mins = n.h * 60 + n.mi;
    var before = isBiz(today, hol) && mins < corte * 60;
    var ship = before ? today : nextBiz(today, hol);
    var cy = cyber(b, today, ship);
    var nota = cy ? ' · en días Cyber, 1 día hábil más' : '';
    var reg = ' · Regiones: 1 a 3 días hábiles';
    var html;
    if (!comuna) {
      html = before
        ? '<b>RM: sale hoy</b> si compras antes de las ' + hora + reg + nota
        : '<b>RM: sale el ' + longDay(nextBiz(today, hol)) + '</b>' + reg + nota;
    } else if (expressList().indexOf(comuna) !== -1) {
      html = before
        ? '<b>Sale hoy a ' + esc(comuna) + '</b> si compras en las próximas ' + dur(corte * 60 - mins) + ' · llega en máx. 24 h hábiles' + nota
        : '<b>Sale el ' + longDay(nextBiz(today, hol)) + ' a ' + esc(comuna) + '</b> · llega en máx. 24 h hábiles' + nota;
    } else {
      var a = nextBiz(ship, hol);
      var z = nextBiz(nextBiz(a, hol), hol);
      html = '<b>Llega entre el ' + (a.getUTCMonth() === z.getUTCMonth() ? shortDay(a) : longDay(a)) + ' y el ' + longDay(z) +
        ' a ' + esc(comuna) + '</b> (estimado' + (cy ? '; en días Cyber, 1 día hábil más' : '') + ')';
    }
    if (out.innerHTML !== html) out.innerHTML = html;
    accNote(cy);
    if (act) {
      var can = !!comunaData();
      var label = comuna ? 'Cambiar comuna' : 'Ingresa tu comuna';
      var ah = can ? '<button type="button" class="byon-link byon-pdp-delivery__btn" data-byon-comuna>' + label + '</button>' : '';
      if (act.innerHTML !== ah) act.innerHTML = ah;
      act.hidden = !can;
    }
  }

  /* Selector de región y comuna dentro de la ficha (datos y guardado de snippets/desplegable-comunas.liquid) */
  function fillTowns(pick, data) {
    var reg = qs('[data-byon-region]', pick);
    var town = qs('[data-byon-town]', pick);
    if (!reg || !town) return;
    var list = (reg.value && data.towns[reg.value]) || [];
    town.innerHTML = '';
    town.add(new Option('Comuna', ''));
    list.forEach(function (t) { town.add(new Option(t, t)); });
    town.disabled = !list.length;
    var saved = savedComuna();
    if (saved && list.indexOf(saved) !== -1) town.value = saved;
  }
  function focus(el) { if (el) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } } }
  function openPicker() {
    var b = box();
    var pick = b ? qs('[data-byon-comuna-pick]', b) : null;
    var data = comunaData();
    if (!pick || !data) return;
    var reg = qs('[data-byon-region]', pick);
    if (reg && reg.options.length < 2) {
      Object.keys(data.cities).forEach(function (code) { reg.add(new Option(data.cities[code], code)); });
    }
    var r = savedRegion();
    if (reg && r && data.towns[r]) reg.value = r;
    fillTowns(pick, data);
    pick.hidden = false;
    focus(reg);
  }
  function save(region, comuna) {
    var hc = d.getElementById('header-select-city');
    var ht = d.getElementById('header-select-town');
    var data = comunaData();
    /* Se guarda a través de los selects de desplegable-comunas: región y comuna puestas y un solo "change" en la
       comuna (su script guarda localStorage, actualiza el header y sincroniza el carro). */
    if (hc && ht) {
      hc.value = region;
      var list = data && data.towns[region] ? data.towns[region] : [comuna];
      while (ht.options.length) ht.remove(0);
      list.forEach(function (t) { ht.add(new Option(t, t)); });
      if (list.indexOf(comuna) === -1) ht.add(new Option(comuna, comuna));
      ht.value = comuna;
      ht.dispatchEvent(new Event('change', { bubbles: true }));
    }
    try { window.localStorage.setItem('region', region); window.localStorage.setItem('comuna', comuna); } catch (e) { /* sin almacenamiento */ }
    track('delivery_comuna_set', {
      region: (data && data.cities[region]) || region,
      comuna: comuna,
      express: expressList().indexOf(comuna) !== -1,
      comuna_source: 'pdp'
    });
  }
  d.addEventListener('change', function (e) {
    var el = e.target;
    var pick = closest(el, '[data-byon-comuna-pick]');
    if (pick) {
      var data = comunaData();
      if (!data) return;
      if (el.hasAttribute('data-byon-region')) {
        fillTowns(pick, data);
        var town = qs('[data-byon-town]', pick);
        if (town && !town.disabled) focus(town);
      } else if (el.hasAttribute('data-byon-town') && el.value) {
        var reg = qs('[data-byon-region]', pick);
        save(reg ? reg.value : '', el.value);
        pick.hidden = true;
        render();
        var btn = qs('[data-byon-comuna]', closest(pick, '[data-byon-delivery]'));
        focus(btn);
      }
      return;
    }
    var id = el && el.id;
    if (id === 'header-select-town' || id === 'header-select-city') setTimeout(render, 80);
  });
  d.addEventListener('click', function (e) {
    if (closest(e.target, '[data-byon-comuna]')) { e.preventDefault(); openPicker(); return; }
    if (closest(e.target, '.guardar-region, .mas-tarde, .header-town-selector-modal .cerrar')) setTimeout(render, 150);
  });
  window.addEventListener('storage', function (e) { if (e.key === 'comuna') render(); });
  window.addEventListener('pageshow', render);
  setInterval(render, 60000);

  render();
  /* desplegable-comunas arma sus listas 300 ms después de cargar: se vuelve a pintar para ofrecer "Ingresa tu comuna". */
  [500, 1500, 3500].forEach(function (ms) { setTimeout(render, ms); });
  window.byonPdpDelivery = { render: render };
})();
